import React from 'react';
import { MultiAnswerProps } from '../../../types/components/user-survey/shared/Answer';
import { SelectedCheck } from '../../../modules/Icons';

export const selectedAnswerClass = 'border-a-blue bg-[#00A1E0] bg-opacity-[8%] text-white';
export const deselectedAnswerClass = 'border-[#393e41] bg-gray-800 text-a-gray hover:bg-[#00A1E0] hover:bg-opacity-[8%] hover:border-a-blue';

const MultiSelectAnswer: React.FC<MultiAnswerProps> = ({
  answer,
  selectedAnswers,
  setSelectedAnswers,
}) => {
  const isSelected = (): boolean =>
    selectedAnswers && selectedAnswers.some(item => item.answerId === answer.answerId);

  const toggleSelection = () => {
    setSelectedAnswers((prev) => {
      const alreadySelected = prev.some(item => item.answerId === answer.answerId);

      if (alreadySelected) {
        return prev.filter(item => item.answerId !== answer.answerId);
      } else {
        return [...prev, answer];
      }
    });
  };

  return (
    <div
      cy-test-id={`answer-${answer.answerId}`}
      className={`transition-all duration-200 ease-in-out transform origin-center h-[52px] items-center border-[1px] border-solid w-full py-2.5 px-3 lg:px-6 flex rounded-[5px] cursor-pointer ${isSelected() ? selectedAnswerClass : deselectedAnswerClass}`}
      onClick={toggleSelection}
    >
      <span className="inter text-14 lg:text-16 lg:leading-24" cy-test-id="answer-text">
        {answer.answerText}
      </span>
      {isSelected() && <SelectedCheck className="hidden ml-auto lg:flex" />}
    </div>
  );
};

export default MultiSelectAnswer;